<template>
  <div class="footer">
    <footer class="page-footer font-small">
      <div class="container-fluid text-center">
        <div class="row">
          <div
            v-for="(column, column_index) in columns"
            :key="column_index"
            class="col font-weight-bold"
          >
            <ul class="list-unstyled">
              <li v-for="(item, item_index) in column" :key="item_index">
                <a :href="item.link">{{ item.name }}</a>
              </li>
            </ul>
          </div>
        </div>
      </div>
      <div class="mx-auto ma-0" style="padding-bottom: 15px; color: #00587d">
        <a href="https://railboxconsulting.com/">Railbox Consulting</a>, LLC
        (dba Western Container Sales) © 2015-{{ new Date().getFullYear() }}
      </div>
    </footer>
  </div>
</template>

<script>
export default {
  name: "FooterUSA",
  data() {
    return {
      columns: {
        first_column: [
          {
            name: "Contact",
            link: "https://westerncontainersales.com/contact/",
          },
        ],
        second_column: [
          {
            name: "Privacy Policy",
            link:
              "https://westerncontainersales.com/about-shipping-containers/privacy-policy/",
          },
        ],
        third_column: [
          {
            name: "Terms & Conditions",
            link:
              "https://westerncontainersales.com/about-shipping-containers/terms-conditions/",
          },
        ],
      },
    };
  },
};
</script>

<style scoped>
@import url(https://maxcdn.bootstrapcdn.com/font-awesome/4.4.0/css/font-awesome.min.css);
@import url(https://cdnjs.cloudflare.com/ajax/libs/font-awesome/4.7.0/css/font-awesome.min.css);

.footer {
  background-color: white;
  font-family: Arial, Helvetica, sans-serif;
  color: #00000080;
}

a {
  color: inherit;
}

a:hover {
  color: #6dbe45;
}
</style>
